// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#event-component .divider {\n  border: none;\n  border-top: 1px solid #ededed;\n}\n\n#event-component .ql-editor {\n  height: 250px !important;\n}\n\n.ql-picker.ql-size .ql-picker-label,\n.ql-picker.ql-size .ql-picker-item {\n  font-size: 0;\n}\n\n.ql-picker.ql-size .ql-picker-label:before,\n.ql-picker.ql-size .ql-picker-item:before {\n  content: attr(data-value) !important;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
